<button type="button" class="card h-100 card-container" [class.client-card]="cardType === 'organization'" [class.project-card]="cardType === 'project'" (click)="notifyParent(cardData)">
  @if (cardType === 'organization') {
    <div class="card-header-row">
      <div
        class="client-avatar"
        [style.background-color]="getAvatarColor(cardData.name)"
      >
        {{ getInitial(cardData.name) }}
      </div>
      <div class="card-icons">
        <span
          *appHasRole="[
            'accello360-organization-admin',
            'accello360-organization-owner',
            'accello360-global-administrator'
          ]"
          class="accello-icon-btn"
          [class.disabled]="isEditLocked"
          [attr.aria-disabled]="isEditLocked"
          matTooltip="Edit item"
          matTooltipPosition="above"
          (keydown.enter)="notifyParent(cardData, 'edit', $event); $event.stopPropagation()"
          (click)="notifyParent(cardData, 'edit', $event); $event.stopPropagation()"
        >
          <img src="assets/images/virtusa-icons/edit_client.svg" alt="edit" />
        </span>
        <span
          *appHasRole="[
            'accello360-organization-admin',
            'accello360-organization-owner',
            'accello360-global-administrator'
          ]"
          class="accello-icon-btn"
          matTooltip="Delete item"
          matTooltipPosition="above"
          (keydown.enter)="notifyParent(cardData, 'delete', $event); $event.stopPropagation()"
          (click)="notifyParent(cardData, 'delete', $event); $event.stopPropagation()"
        >
          <img src="assets/images/virtusa-icons/delete-red.svg" alt="delete" />
        </span>
      </div>
    </div>
    <div class="client-content">
      <span
        class="client-name accello-general-text7"
        [matTooltip]="cardData.name"
        matTooltipPosition="above"
        matTooltipClass="tooltip-left-align"
      >{{ cardData.name }}</span>
      <p
        class="client-description accello-general-text10"
        [matTooltip]="cardData.description ?? ''"
        matTooltipPosition="above"
        matTooltipClass="tooltip-left-align"
      >{{ cardData.description }}</p>
    </div>
  } @else {
    <!-- Edit and Delete icons, visible on hover -->
    <div class="card-icons top-0 end-0 m-4">
      <span
        *ngIf="showAddUsers"
        class="accello-icon-btn"
        matTooltip="Add Users"
        matTooltipPosition="above"
        (keydown.enter)="notifyParent(cardData, 'admin', $event); $event.stopPropagation()"
        (click)="notifyParent(cardData, 'admin', $event); $event.stopPropagation()"
      >
        <img src="assets/images/virtusa-icons/add-people.svg" alt="add" />
      </span>
      <span
        *ngIf="showProjectEdit"
        class="accello-icon-btn"
        [class.disabled]="isEditLocked"
        [attr.aria-disabled]="isEditLocked"
        matTooltip="Edit item"
        matTooltipPosition="above"
        (keydown.enter)="notifyParent(cardData, 'edit', $event); $event.stopPropagation()"
        (click)="notifyParent(cardData, 'edit', $event); $event.stopPropagation()"
      >
        <img src="assets/images/virtusa-icons/edit-project.svg" alt="edit" />
      </span>
      <span
        *appHasRole="[
          'accello360-organization-admin',
          'accello360-organization-owner',
          'accello360-global-administrator'
        ]"
        class="accello-icon-btn"
        matTooltip="Delete item"
        matTooltipPosition="above"
        (keydown.enter)="notifyParent(cardData, 'delete', $event); $event.stopPropagation()"
        (click)="notifyParent(cardData, 'delete', $event); $event.stopPropagation()"
      >
        <img src="assets/images/virtusa-icons/delete-red.svg" alt="delete" />
      </span>
    </div>

    <div class="image-container">
      <img [src]="updateImage()" alt="Project cover" class="card-img-top" />
    </div>
    <span class="card-name accello-general-text7" [matTooltip]="cardData.name" matTooltipPosition="above" matTooltipClass="tooltip-left-align">{{ cardData.name }}</span>

    <div class="card-body">
      <p class="accello-general-text10" [matTooltip]="cardDescription" matTooltipPosition="above" matTooltipClass="tooltip-left-align">
        {{ cardDescription }}
      </p>
      <div class="d-flex align-items-end justify-content-end">
        <img src="assets/images/virtusa-icons/arrow.svg" alt="arrow" />
      </div>
    </div>
  }
</button>
